import React, { useContext, useEffect, useState, lazy } from 'react'
import { ApolloProvider, Query } from 'react-apollo'
import { HashRouter, BrowserRouter, Route, Switch } from 'react-router-dom'
import { setupClient } from 'apolloClient'
import { GET_ERRORS } from './graphql/queries'
import { hotjar } from 'react-hotjar'

const SearchResults = lazy(() => import('./routes/SearchResults'))
const BulkSearch = lazy(() => import('./pages/Domains/BulkSearch'))
const BulkResult = lazy(() => import('./pages/Domains/BulkSearch/BulkResult'))
const HomePage = lazy(() => import('./pages/Homepage'))
const FAQ = lazy(() => import('./pages/Faq'))
const Contact = lazy(() => import('./pages/contact'))
const Learn = lazy(() => import('./pages/Learn'))
const Pricing = lazy(() => import('./pages/pricing'))
const Domains = lazy(() => import('./pages/Domains'))
const Account = lazy(() => import('./pages/Account'))
const PrivacyAndPolicy = lazy(() => import('./pages/PrivacyAndPolicy'))
const TermsOfUse = lazy(() => import('./pages/TermsOfUse'))
const AffliatePage = lazy(() => import('./pages/AffliatePage'))

import Modal from './components/Modal/Modal'
import Confirm from './components/SingleName/Confirm'
import { NetworkError, Error404 } from './components/Error/Errors'
import { CONFIRM } from './modals'
import ExpiryNotificationModal from './components/ExpiryNotification/ExpiryNotificationModal'
import MainPanel from './container/MainPanel'
import GlobalStyle from './GlobalStyle'
import { setup as setupAnalytics } from './utils/analytics1'
// import StackdriverErrorReporter from 'stackdriver-errors-js'
import GlobalState from './globalState'
import { handleNetworkChange } from './utils/utils'
import LearnArticle from 'pages/Learn/LearnArticle'
import { useLocale } from 'hooks/useLocale'
import { useTranslation } from 'react-i18next'

// const TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID
const HOTJAR_ID = process.env.REACT_APP_HOT_JAR_ID

// const errorHandler = new StackdriverErrorReporter()

// If we are targeting an IPFS build we need to use HashRouter
const Router =
  process.env.REACT_APP_IPFS === 'True' ? HashRouter : BrowserRouter

// ReactGA.initialize(TRACKING_ID)

const App = () => {
  const { currentNetwork } = useContext(GlobalState)
  let [currentClient, setCurrentClient] = useState(null)
  const { locale } = useLocale()
  const { i18n } = useTranslation()

  const initApps = async () => {
    const { client } = await handleNetworkChange()
    setCurrentClient(client)
    return { client }
  }

  useEffect(() => {
    initApps()
  }, [])

  useEffect(() => {
    if (currentNetwork) {
      setupClient(currentNetwork).then(client => setCurrentClient(client))
    }
  }, [currentNetwork])

  useEffect(() => {
    i18n.changeLanguage(locale)
  }, [locale])

  useEffect(() => {
    hotjar.initialize(HOTJAR_ID)
  }, [])

  return (
    <>
      <GlobalStyle />
      {currentClient && (
        <ApolloProvider client={currentClient}>
          <Query query={GET_ERRORS}>
            {({ data }) => {
              setupAnalytics()
              // errorHandler.start({
              //   key: 'AIzaSyDW3loXBr_2e-Q2f8ZXdD0UAvMzaodBBNg',
              //   projectId: 'idyllic-ethos-235310'
              // })

              if (data && data.error && data.error.message) {
                return <NetworkError message={data.error.message} />
              } else {
                return (
                  <>
                    <Router>
                      <Switch>
                        <MainPanel>
                          <Route exact path="/">
                            <HomePage />
                          </Route>
                          <Route path="/faq">
                            <FAQ />
                          </Route>
                          <Route path="/contact">
                            <Contact />
                          </Route>
                          <Route exact path="/learn">
                            <Learn />
                          </Route>
                          <Route path="/learn/:id/:slug">
                            <LearnArticle />
                          </Route>
                          <Route path="/pricing">
                            <Pricing />
                          </Route>
                          <Route path="/name/:name">
                            <Domains />
                          </Route>
                          <Route path="/bulksearchstart">
                            <BulkSearch />
                          </Route>
                          <Route path="/bulkresult">
                            <BulkResult />
                          </Route>
                          <Route path="/search/:searchTerm">
                            <SearchResults />
                          </Route>
                          <Route path="/account">
                            <Account />
                          </Route>
                          <Route path="/privacy-and-policy">
                            <PrivacyAndPolicy />
                          </Route>
                          <Route path="/terms-of-use">
                            <TermsOfUse />
                          </Route>
                          <Route path="/affliate">
                            <AffliatePage />
                          </Route>

                          {/* <Route path="*">
                          <Error404 />
                        </Route> */}
                        </MainPanel>
                      </Switch>
                    </Router>
                    <Modal name={CONFIRM} component={Confirm} />
                    <ExpiryNotificationModal />
                  </>
                )
              }
            }}
          </Query>
        </ApolloProvider>
      )}
    </>
  )
}
export default App
